export default "__VITE_ASSET__c3a168a4__"